import * as React from "react";
import {useMemo, useState} from "react";
import {ILoginTabResponse} from "../../../../api/AdminAnalyticsApi";
import {applySort, SortDir} from "../../../../utils/listUtil";
import {sortTh} from "../shared/SortableTh.component";
import {formatMonthLabel} from "../shared/analytics.format";
import {numberWithCommas} from "../../../../utils/numberUtil";

interface ILoginComparisonTableProps {
    comparison: ILoginTabResponse["monthlyComparison"];
}

export const LoginComparisonTable: React.FC<ILoginComparisonTableProps> = ({comparison}) => {
    const [loginComparisonSort, setLoginComparisonSort] = useState<{ col: string; dir: SortDir }>({
        col: "month",
        dir: "desc",
    });
    const sortedLoginComparison = useMemo(
        () => applySort(comparison, loginComparisonSort.col, loginComparisonSort.dir),
        [comparison, loginComparisonSort]);

    return (
        <>
            <h3 className="admin-analytics__subsection-title">Month-over-Month / Year-over-Year</h3>
            <table className="admin-analytics__table">
                <thead>
                <tr>
                    {sortTh("month", "Month", loginComparisonSort, setLoginComparisonSort, undefined, "desc")}
                    {sortTh("total", "Total", loginComparisonSort, setLoginComparisonSort,
                        "admin-analytics__cell--right")}
                    {sortTh("momPercent", "MoM", loginComparisonSort, setLoginComparisonSort,
                        "admin-analytics__cell--right")}
                    {sortTh("yoyPercent", "YoY", loginComparisonSort, setLoginComparisonSort,
                        "admin-analytics__cell--right")}
                </tr>
                </thead>
                <tbody>{sortedLoginComparison.map((row) => (
                    <tr key={row.month}>
                        <td>{formatMonthLabel(row.month)}</td>
                        <td className="admin-analytics__cell--right">{numberWithCommas(row.total)}</td>
                        <td className="admin-analytics__cell--right">
                            {row.momPercent === undefined ? "-" : `${row.momPercent}%`}
                        </td>
                        <td className="admin-analytics__cell--right">
                            {row.yoyPercent === undefined ? "-" : `${row.yoyPercent}%`}
                        </td>
                    </tr>
                ))}</tbody>
            </table>
        </>
    );
};
